const RAZORPAY_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

export function loadRazorpayScript() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Razorpay is only available in the browser'));
  }

  if (window.Razorpay) {
    return Promise.resolve(window.Razorpay);
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = RAZORPAY_SCRIPT_URL;
    script.async = true;
    script.onload = () => {
      if (window.Razorpay) resolve(window.Razorpay);
      else reject(new Error('Razorpay failed to initialize'));
    };
    script.onerror = () => reject(new Error('Failed to load Razorpay checkout'));
    document.body.appendChild(script);
  });
}

export async function openRazorpayCheckout({
  key,
  orderId,
  amountInPaise,
  currency = 'INR',
  name = 'CHSE Express',
  description,
  onSuccess,
  onDismiss,
}) {
  const Razorpay = await loadRazorpayScript();

  return new Promise((resolve, reject) => {
    const options = {
      key,
      amount: amountInPaise,
      currency,
      order_id: orderId,
      name,
      description,
      handler: (response) => {
        Promise.resolve(onSuccess?.(response)).then(resolve).catch(reject);
      },
      modal: {
        ondismiss: () => {
          onDismiss?.();
          resolve({ dismissed: true });
        },
      },
    };

    const checkout = new Razorpay(options);
    checkout.on('payment.failed', (response) => {
      reject(new Error(response?.error?.description || 'Payment failed'));
    });
    checkout.open();
  });
}
